<template>
<el-dialog
    title="组合铺货"
    :visible.sync="visible"
    width="1000px"
    class="edit-dialog"
    @close="handleClose"
>
    <div class="platform-info-edit-wrp ft-12">
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="12%">
            <slot name="errMsg"></slot>
            <section>
                <div class="title ft-12">
                    <span>基础信息</span>
                </div>
                <div class="conf">
                    <el-form-item label="商品分类:" prop="categoryIds">
                       <div class="category ft-12">
                            <category-input v-model="value.categoryIds" platform="pdd" ref="categoryInput"/>
                       </div>
                    </el-form-item>
                    <el-form-item label="商品标题" prop="goodsName">
                        <el-input
                            type="text"
                            placeholder="请输入"
                            v-model="value.goodsName"
                            >
                            <span slot="suffix" style="margin-right: 6px;">{{titleLength}}/60</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="商品描述" prop="goodsDesc">
                        <el-input
                            type="text"
                            placeholder="请输入商品描述"
                            v-model="value.goodsDesc"
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="类目属性" v-if="value.categoryIds.length">
                        <CategoryAttr 
                            v-model="value.itemPropValues" 
                            :categoryIds="value.categoryIds" 
                            @updateSpec="updateSpec"
                            @updateDiscount="updateDiscount"
                            :shopList="shopList"
                            ref="categoryAttr"/>
                    </el-form-item>
                    <el-form-item label="商品轮播图:" prop="carouselGallery">
                        <div class="imgs-wrp">
                            <div class="ft-12">展示时只取主图，拖动可调整顺序</div>
                            <MutiImgUpload 
                                v-model="value.carouselGallery"
                                ref="carouselGallery"
                                limitSuffix=".jpg,.jpeg,.png" 
                                :limitNums="50"
                                :limitHeight="[480, 0]"
                                :limitWidth="[480, 0]"
                                :limitSize="3 * 1024 * 1024"
                                :size="200"
                                :aspectRatio="[1,0.75]"
                                aspectRatioText="1:1或3:4"
                                :uploadFunc="uploadFunc"/>
                            <div class="tips ft-12">
                                <span>图片格式支持JPEG/JPG/PNG， 图片尺寸长宽比1：1且尺寸不低于480px，图片大小最高3MB；</span>
                                <span>支持批量传图，最多上传50张图片</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品详情图:" prop="detailGallery">
                        <div class="imgs-wrp">
                            <MutiImgUpload 
                                v-model="value.detailGallery"
                                ref="detailGallery"
                                :mainImgNums="0" 
                                :limitNums="50"
                                limitSuffix=".jpg,.png,.jpeg" 
                                :limitHeight="[0, 1500]"
                                :limitWidth="[480, 1200]"
                                :limitSize="3 * 1024 * 1024"
                                :uploadFunc="uploadFunc"/>
                            <div class="tips ft-12">
                                <span>尺寸要求宽度处于480~1200px之间，高度0-1500px之间, 大小3M以内</span>
                                <span>最多上传50张, 图片格式仅支持JPG,JPEG,PNG格式</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品活动素材图:" prop="imageUrl">
                        <div class="imgs-wrp">
                            <div class="img-ctx">
                                <div>
                                    <div>商品白底图: </div>
                                    <ImgUpload
                                        :width="80"
                                        :height="80"
                                        :file="value.imageUrl1.content"
                                        @upload-success="(url) => uploadImgSuccess(url, 1)"
                                        @del="() => {deleteImg(1)}"
                                        :isSingle="true"
                                    />
                                </div>
                                <div>
                                    <div>商品长图: </div>
                                    <ImgUpload
                                        :width="80"
                                        :height="80"
                                        :file="value.imageUrl3.content"
                                        @upload-success="(url) => uploadImgSuccess(url, 3)"
                                        @del="() => {deleteImg(3)}"
                                        :isSingle="true"
                                    />
                                </div>
                            </div>
                            <div class="tips ft-12">
                                <span>*商品发布成功且审核通过后，系统会自动上传素材图片,请耐心等待</span>
                                <span>若商品审核被拒，素材会上传失败</span>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </section>
            <section>
                <div class="title">
                    <span>商品规格与库存</span>
                </div>
                <div class="conf">
                    <template>
                        <template v-if="value.categoryIds.length">
                            <el-form-item v-if="canNoteItems.length" label="尺码类型:" prop="sizeType">
                                <el-radio-group v-model="value.sizeType" class="radio-wrap">
                                    <el-radio :label="item.id" v-for="item in specTypes" :key="item.id">{{item.name}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="商品规格:" prop="skuAttrs">
                                <PddSpecification 
                                    ref="pddSpecification"
                                    :sizeType="value.sizeType"
                                    :canNoteItems="canNoteItems"
                                    v-model="specifications"
                                    :isPdd="true"
                                    :getPddSpecList="getPddSpecList"
                                />
                            </el-form-item>
                            <el-form-item label="价格库存:" prop="skuAttrsDetail">
                                <FormItemSkuList
                                    ref="skuList"
                                    :specifications="specifications"
                                    :tableCols="skuTableCols"
                                    v-model="skuList"
                                    :imgOnlyPreview="skuImgOnlyPreview"
                                    :uploadFunc="uploadFunc"
                                    :isPdd="true"
                                    :selectSpecList="selectSpecList"
                                    :noteItemLen="canNoteItems.length"
                                    :specNum="specNum"
                                    @validateSkuRow="validateSkuRow"
                                    @validateSkuRows="validateSkuRows"
                                >
                                    <!-- <template slot="outSkuSnHeaderSlot">
                                        <span style="color: red">*</span>sku编码<el-button @click="batchGenSkuOutrerId" type="link">批量生成</el-button>
                                    </template> -->
                                </FormItemSkuList>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item label="商品规格:" prop="skuAttrs">
                                <span class="no-suport ft-12">暂不支持的类目或当前类目无销售属性</span>
                            </el-form-item>
                        </template>
                    </template>
                     <el-form-item label="商品参考价:" prop="marketPrice">
                         <el-input
                            type="text"
                            placeholder=""
                            v-model="value.marketPrice"
                            width="200px"
                            :rules="[
                                {required: true, message: '请输入商品市场价'},
                                {validator: this.validatePrice}
                            ]"
                            >
                        </el-input><span class="text">元</span>
                    </el-form-item>
                     <template v-if="value.categoryIds.length">
                         <el-form-item 
                            label="满件折扣:" 
                            prop="twoPiecesDiscount"
                            :rules="twoPiecesDiscountRules"
                            >
                            <span class="text">满2件</span>
                            <el-input-number
                                v-model="value.twoPiecesDiscount"
                                style="width: 150px"
                                :precision="1"
                                :controls="false"
                                :max="twoPiecesDiscountRule.maxTwoPiecesDiscount / 10"
                                :min="twoPiecesDiscountRule.minTwoPiecesDiscount / 10"
                            ></el-input-number>
                            <span class="text">折</span>
                            <span class="note">注: 商品满2件折扣与店铺满2件折扣不会叠加, 最低{{ twoPiecesDiscountRule.minTwoPiecesDiscount / 10 }}折, 最高{{ twoPiecesDiscountRule.maxTwoPiecesDiscount/10 }}折。</span>
                        </el-form-item>
                    </template>
                    <el-form-item label="商品编码:" prop="goodsSn">
                         <el-input
                            type="text"
                            placeholder=""
                            v-model="value.goodsSn"
                            width="200px"
                            >
                        </el-input>
                    </el-form-item>
                </div>
            </section>
            <section>
                <div class="title">
                    <span>服务与承诺</span>
                </div>
                <div class="conf">
                    <el-form-item label="商品类型:" prop="goodsType">
                         <el-radio-group v-model="value.goodsType">
                            <el-radio v-for="item in PROD_TYPE" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="货源地:" prop="countryId" v-if="value.goodsType === 2 || value.goodsType === 3">
                        <el-select 
                            v-model="value.countryId"
                            clearable
                            filterable
                            width="200px"
                            :loading="countryLoading"
                            @visible-change="getPddCountryList"
                        >
                            <el-option
                                v-for="(item, idx) in ADDROPTIONS"
                                :key="idx"
                                :label="item.countryName"
                                :value="item.countryId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否二手:" prop="secondHand">
                         <el-radio-group v-model="value.secondHand">
                            <el-radio v-for="item in SECOND_TYPE" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否预售:" prop="isPreSale">
                         <el-radio-group v-model="value.isPreSale">
                            <el-radio v-for="item in PRESELL_TYPE" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="预售时间:" prop="preSaleTime" v-if="value.isPreSale === 1">
                        <el-input-number
                            v-model="value.preSaleTime"
                            controls-position="right"
                            :min="3"
                            :max="29"
                            width="100px"
                            style="text-align: left"
                        ></el-input-number>
                        <span style="margin-left: 5px; font-size: 12px">天结束预售</span>
                    </el-form-item>
                    <el-form-item label="承诺发货时间:" prop="shipmentLimitSecond">
                         <el-radio-group v-model="value.shipmentLimitSecond">
                            <el-radio v-for="item in DELAY_TIME" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="拼单要求:" prop="groupRequiredCustomerNum">
                         <span class="text" style="margin-right: 10px">拼单人数:</span>
                         <el-input
                            type="text"
                            v-model="value.groupRequiredCustomerNum"
                            width="100px"
                            disabled
                         ></el-input>
                    </el-form-item>
                    <template v-if="value.categoryIds.length">
                        <el-form-item label="服务:">
                            <span class="text">无</span>
                        </el-form-item>
                        <el-form-item label="承诺:" prop="promise">
                            <div><el-checkbox v-model="value.promise.isRefundable">7天无理由退换货<span class="no-suport" style="margin-left: 10px">必须支持【七天无理由退换货】服务</span></el-checkbox></div>
                            <div><el-checkbox v-model="value.promise.isFolt">假一赔十<span class="no-suport" style="margin-left: 10px">该类商品，必须支持假一赔十服务</span></el-checkbox></div>
                        </el-form-item>
                    </template>
                </div>
            </section>
        </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="sure">铺 货</el-button>
    </span>
    <GenSkuOuterIdDialog ref="genSkuOuterIdDialog" />
    <ProgressDialog ref="progressDialog" :percentage="percentage"/>
</el-dialog>
</template>
<script>
import '@/assets/css/prod.scss';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import ImgUpload from '@/components/Uploads/ImgUpload.vue';
import {groupProdsOnSelf} from '@/servers/prod/center/index.js'

import {specification_mixin} from './FormSpecItem';
import CategoryInput from '../../../components/PlatformCategoryInput/index.vue';
import GenSkuOuterIdDialog from '../../GenSkuOuterIdDialog.vue'
import ProgressDialog from './progressDialog.vue';
import RULES, {validateSkuPrice} from '../../../components/PddInfoForm/rules';
import _ from 'lodash';
import CategoryAttr from '../../../components/PddInfoForm/components/CategoryAttr.vue';
import {SIZE_TYPE, PROD_TYPE, SECOND_TYPE, PRESELL_TYPE, DELAY_TIME} from '../../../components/PddInfoForm/config';
import {
    getPddSpecList, 
    getPddCountryList, 
    pddDataMap,
    uploadFile,
    getPddDetail,
    getPddDetailSupplier,
    getPddSpecId
} from '@/servers/prod/center/pdd.js'
import {
  publishGoodsResult
} from '@/servers/prod/center';
import {getLenWith, transToBase64} from '../../../components/PddInfoForm/utils';
import {transFormData, generateSpecifications, getPublishEntrance} from '../utils/index';
import { mapActions, mapGetters, mapMutations} from "vuex";
import {getShopList} from '@servers/base/shop/index.js';

export default {
    mixins: [specification_mixin],
    components: {
        MutiImgUpload,
        ImgUpload,
        CategoryInput,
        CategoryAttr,
        GenSkuOuterIdDialog,
        ProgressDialog
    },
    props: {
        closeStepsDialog: {
            type: Function
        },
        isGroupPuhuo: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            visible: false,
            formData: {},
            shops: [],
            selectSpecList: [], // 上一步编辑选择的规格
            needValiSymbol: true, // 校验规格名规格值非法字符
            mixinsFormKey: 'value',
            SIZE_TYPE: SIZE_TYPE,
            PROD_TYPE: PROD_TYPE,
            SECOND_TYPE: SECOND_TYPE,
            PRESELL_TYPE: PRESELL_TYPE,
            DELAY_TIME: DELAY_TIME,
            ADDROPTIONS: [],
            isPdd: true,
            skuImgOnlyPreview: false,
            specification_needImg: true, // 规格需要校验图片
            // ADDROPTIONS: [{countryId: 1, countryName: "安道尔"}, {countryId: 2, countryName: "阿联酋"}],
            countryLoading: false, // 货源地国家下拉框loading
            canNoteItems: [],
            percentage: 0, // 铺货进度
            intervalId: null,
            timeoutId: null,
            specNum: 0, // 有几个规格
            value: {
                categoryIds: [],  // 商品分类
                goodsName: '', // 商品标题
                goodsDesc: '',// 商品描述
                carouselGallery: [], // 商品轮播图
                detailGallery: [], // 商品详情图
                imageUrl: '', // 商品活动素材图 *
                imageUrl1: {content: ''}, // 商品白底图
                imageUrl3: {content: ''}, // 商品长图
                itemPropValues: [], // 类目属性 *
                sizeType: 1, // 尺码类型
                marketPrice: '', // 市场价
                goodsSn: '', // 商品编码
                goodsType: '1', // 商品类型
                countryId: '', // 货源地 受goodsType影响
                secondHand: 1, // 是否二手
                isPreSale: 1, // 是否预售
                preSaleTime: '', // 预售时间
                shipmentLimitSecond: '', // 承诺发货时间 受goodsType影响
                groupRequiredCustomerNum: '2', // 拼单人数 成团人数
                promise: {isRefundable: true, isFolt: true}, // 承诺
                // isRefundable: 1, // 是否七天无理由
                // isFolt: 1, // 是否假一赔十
                skuList: [],
                specifications: [],
                twoPiecesDiscount: '9.5', // 满件折扣
                primitiveTwoPiecesDiscount: '' // 满件折扣的初始值
            },
            skuTableCols: [
                {prop: 'multiPrice', validate: true, attrs: {label: '拼单价', width: 120}, input: {type: 'number', validator: validateSkuPrice}},
                {prop: 'singlePrice', validate: true, attrs: {label: '单买价', width: 120}, input: {type: 'number', validator: validateSkuPrice}},
                {prop: 'quantity', attrs: {label: '库存', noRequired: true}, input: {type: 'number'}},
                {prop: 'weight', attrs: {label: '重量', noRequired: true}, input: {type: 'number'}},
                {prop: 'outSkuSn', validate: true, attrs: {label: 'sku编码', noRequired: true, width: 140}},
            ],
            twoPiecesDiscountRule: '',// 满件折扣规则
            twoPiecesDiscountRules: [],  // 满件折扣表单验证是否必填
            baseItemIds: [],
            closeFun: null,
            onSuccess: null,
            groupPuhuoShopList: [],
            shopList: [],
        }
    },
    inject: {
        from: {
            default: null
        },
        supplierCompanyId: {
            default: null
        },
        pageId: {
            default: null
        }
    },
    computed: {
        ...mapGetters(['routerPrefix']),
        rules () {
            return RULES(this);
        },
        titleLength() {
            const goodsName = this.value.goodsName || '';
            return getLenWith(goodsName);
        },
        showPddSpec() {
            return this.canNoteItems.length;
        },
        specTypes() {
            if (!this.showPddSpec) return [];
            const sizeItem = this.canNoteItems[1];
            if(!sizeItem) return [];
            let arr = sizeItem.values.reduce((acc, it) => {
                if (it.group) {
                    const idx = acc.findIndex(a => a.id === it.group.id);
                    if (idx === -1) {
                        acc.push(it.group);
                    }
                }
                return acc;
            }, []);
            const idx = arr.findIndex(a => a.id === this.value.sizeType);
            if (idx === -1 && arr[0]) {
                this.value.sizeType = arr[0].id;
            }
            return arr;
        },
        minMarketPrice() {
            let max = this.skuList.reduce((acc, row) => {
                if (acc < row.singlePrice) {
                    acc = row.singlePrice;
                }
                return acc;
            }, 0);
            return max + 1;
        }
    },
    watch: {
        formData: {
            handler(v) {
                v = transFormData(v);
                if (v.skuList) {
                    v.skuList = v.skuList.map(item => {
                        const _skuid = item.skuSpecifications.map(sp => sp.valueKey).join('-')
                            return {
                                ...item,
                                _skuid
                            }
                        
                    })
                }
                this.specifications = generateSpecifications(this.selectSpecList);
                this.$set(this, 'value', {...this.value, ...v})
            },
            immediate: true,
            deep: true
        },
        minMarketPrice(v) {
            if (this.value.marketPrice < v) {
                this.value.marketPrice = v;
            } else {
                if (this.value.marketPrice / (v-1) >= 10) {
                    this.value.marketPrice = (v-1) * 5;
                }
            }
        },
    },
    methods: {
         //铺货进度查询
        ...mapActions(['publishSpeed']),
        ...mapMutations(['setCurrentPage']),
        async method_open({formData, specList, shops, specNum, rowsData, closeFun, onSuccess} = {}) {
            this.visible = true;
            this.selectSpecList = specList;
            this.groupPuhuoShopList = shops;
             // 需要请求拼多多平台资料
            let res = null;
            // 供销商小店的组合铺货需调不同接口
            if (this.from === 'supplierShop') {
                res = await getPddDetailSupplier({baseItemId: formData.baseItemId, companyId: this.supplierCompanyId },{isDistributor: false})
            } else {
                res = await getPddDetail({baseItemId: formData.baseItemId },{isDistributor: false})
            }
            if(!res) return;
            this.formData = {...formData, isOnshelf: res.isOnshelf, templateConfig: res.templateConfig};
            const shopIds = shops.map(item => item.shopId)
            this.shops = [...shopIds];
            this.specNum = specNum;
            this.baseItemIds = rowsData.map(item => item.baseItemId);
            this.closeFun = closeFun;
            this.onSuccess = onSuccess;
            // this.value = {...this.value, ...formData};
        },
        handleClose() {
            this.visible = false;
            // this.formData = {};
            this.value.categoryIds = [];
            this.shops = [];
            this.selectSpecList = [];
            this.skuList = [];
            this.canNoteItems = [];
            this.groupPuhuoShopList = [];
        },
        method_close() {
            this.visible = false;
        },
        // 生成sku编码按钮回调
        batchGenSkuOutrerId() {
            this.$refs.genSkuOuterIdDialog.method_open({
                skuList: this.skuList,
                outerId: this.formData.outerId,
                field: 'outSkuSn'
            }, (skuList) => {
                this.skuList = skuList;
                this.$nextTick(() => {
                    this.validateSkuRows();
                })
            })
        },
        // 获取规格名列表
        getPddSpecList() {
            let leafId = '';
            const categoryIds = this.value.categoryIds; 
            if (categoryIds && categoryIds.length) {
                leafId = categoryIds[categoryIds.length-1]
            }
            return getPddSpecList({
                leafCategoryId: leafId
            });
        },
        getPddCountryList() {
            // ADDROPTIONS
            if (!this.ADDROPTIONS.length) {
                this.countryLoading = true;
                getPddCountryList({}).then(list => {
                    if (list) {
                        this.ADDROPTIONS = list;
                        this.countryLoading = false;
                        const countryId = this.value.countryId;
                        this.value.countryId = 0;
                        this.$nextTick(() => {
                            this.value.countryId = countryId;
                        })
                    }
                })
            }
        },
        async uploadImgSuccess(url, type) {
            this.value.imageUrl = url;
            this.value[`imageUrl${type}`] = {
                content: url,
                fileId: '',
                materialType: type
            }
        },
        deleteImg(type) {
            this.value[`imageUrl${type}`] = {};
        },
        formatSepcValue(item, idx) {
            let val = {
                checked: item.checked,
                note: item.note || '',
                parentSpecId: item.propId || item.parentSpecId,
                specId: item.propValueId || item.specId,
                vvalue: item.value,
                valueKey: item.valueKey,
                refPid: item.refPid,
                groupId: item.groupId,
                vid: item.vid,
            }
            if (idx === 0) {
                val.imgUrl = item.imageUrl;
            }
            
            if (idx === 1 && this.showPddSpec && !val.groupId) {
                val.groupId = this.value.sizeType;
                // delete val.vid;
            }
            return val;
        },
        putSpecToItemPropValues (){
            const specifications = _.cloneDeep(this.value.specifications);
            const refPids = this.canNoteItems.map(item => item.refPid);
            let itemPropValues = _.cloneDeep(this.value.itemPropValues);
            itemPropValues = itemPropValues.filter(item => !refPids.includes(item.refPid));
            specifications.forEach((spec, idx) => {
                (spec.values || []).forEach(item => {
                    itemPropValues.push(this.formatSepcValue(item, idx))
                })
            });
            return itemPropValues;
        },
        
        async uploadFunc(file) {
            const base64 = await transToBase64(file);
            let error = '';
            if (base64) {
                const imgUrl = await uploadFile({image: base64});
                if (imgUrl) {
                    return {url: imgUrl || ''};
                }
            } else {
                error = '文件转base64错误！'
                this.$message.error('文件转base64错误！')
            }
            return Promise.reject(error || '');
        },
        validatePrice(rule, value, callback) {
            value = String(value);
            const valueNum = Number(value);
            const idx = value.lastIndexOf('.');
            const mStr = value.slice(idx+1);
            if (isNaN(valueNum)) {
                callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
            } else if (valueNum < 0) {
                callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
            } else if (idx !== -1 &&  mStr.length > 2) {
                callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
            } else if (valueNum < this.minMarketPrice) {
                callback(new Error('不允许小于单买价的最大值+1'));
            } else {
                callback();
            }
        },
        validateSkuRows() {
            let flags = [];
            const skuList = JSON.parse(JSON.stringify(this.skuList));
            this.skuTableCols.forEach(col => {
                if (col.input && col.validate) {                    
                    skuList.forEach(row => {
                        flags.push(this.validateSkuRow(row, col.prop));
                    })
                }
            })
            const flag = flags.some(fl => fl === false)
            if (flag) {
                this.$message.error('请正确填写价格库存列表');
            }
            this.skuList = skuList;
            return flag;
        },
        validateSkuRow(row, field, scope) {
            if(row.disabled) return true;
            let valid = true;
            let msg = '';
            if (!row[field] && field !== 'quantity' && field !== 'weight') {
                msg = '必填';
            } else {
                if (field === 'singlePrice') {
                    if (row.singlePrice === '') {
                        msg = '必填';
                    } else if (row.singlePrice <= 0) {
                        msg = '最小0.01';
                    } else if (row.singlePrice < (row.multiPrice + 1)) {
                        msg = '需大于拼单价+1'
                    }
                } else if (field === 'multiPrice') {
                    if (row.multiPrice === '') {
                        msg = '必填';
                    } else if (row.multiPrice <= 0) {
                        msg = '最小0.01';
                    }
                    if (row.singlePrice < (row.multiPrice + 1)) {
                        row[`singlePriceError`] = '需大于拼单价+1'
                        valid = false;
                    } else {
                        delete row[`singlePriceError`];
                        valid = true;
                    }
                }
            }
            if (msg) {
                row[`${field}Error`] = msg;
                valid = false;
            } else {
                delete row[`${field}Error`];
            }
            if (scope) { // 单个校验
                const idx = scope.$index;
                const skuList = JSON.parse(JSON.stringify(this.skuList));
                skuList[idx] = {...row};
                this.skuList = skuList;
            }
            return valid;
        },
        generateNewSpec(item) {
            return {
                checked: true,
                value: '无规格',
                isNoSpec: true,
                valueKey: '',
                parentSpecId: item.parentSpecId || '',
                specId: '',
                groupId: '',
                refPid: item.refPid,
                vid: '',
                note: '',
            }
        },
        getPropSpecifications(canNoteItems, specifications) {
            const specs = [];
            // const itemPropValues = this.value.itemPropValues;
            canNoteItems.forEach((item, idx) => {
                const curSpec = specifications[idx];
                const spec = {
                    parentSpecId: item.parentSpecId,
                    name: item.name,
                    nameKey: item.nameKey || (curSpec && curSpec.nameKey) || item.name,
                };
                // let values = itemPropValues.filter(it => it.parentSpecId === item.parentSpecId);
                // if (!values.length && curSpec) {
                let values = (curSpec && curSpec.values) || [];
                // }
                if (!values.length ) {
                    spec.values =[this.generateNewSpec(item)];
                } else {
                    spec.values = values.map((propV) => {
                        let val = {
                            checked: propV.checked,
                            value: propV.vvalue || propV.value,
                            valueKey: propV.valueKey,
                            parentSpecId: item.parentSpecId || '',
                            specId: propV.specId || '',
                            groupId: propV.groupId,
                            refPid: item.refPid,
                            vid: propV.vid,
                            note: propV.note || '',
                        }
                        if (idx === 0) {
                            val.imageUrl = propV.imgUrl || propV.imageUrl ||'';
                        }
                        if (propV.parentSpecId !== item.parentSpecId) {
                            val.specId = '';// 校验时注意校验specId
                        }
                        return val;
                    })
                }
                specs.push(spec);
            });
            return specs;
        },
        /**
         * 根据商品属性更新商品规格和规格类型
         */
        updateSpec(canNoteItems) {
            this.canNoteItems = canNoteItems;
            if (canNoteItems.length) {
                if (this.specNum > 1 && canNoteItems.length <= 1) {
                    this.$alert('组合商品包含双规格商品，请选择双规格类目！', '警告', {type: 'warning'});
                } 
                this.specifications = this.getPropSpecifications(canNoteItems, generateSpecifications(this.selectSpecList));
            } else {
                this.specifications = generateSpecifications(this.selectSpecList);
            }
        },
        // 获取满件折扣：满两件折扣的规则
        updateDiscount(twoPiecesDiscountRule) {
            this.twoPiecesDiscountRule = twoPiecesDiscountRule;
            if (twoPiecesDiscountRule.ifMustTwoPiecesDiscount) {
                // 必填
                this.twoPiecesDiscountRules = [
                     {required: true, message: '请输入满件折扣'},
                ]
            } else {
                 // 非必填
                this.twoPiecesDiscountRules = [];
            }
            if (!this.value.primitiveTwoPiecesDiscount) {
                    this.value.twoPiecesDiscount = twoPiecesDiscountRule.recommendTwoPiecesDiscount / 10;
                }
        },
        updateSkuListPropValueId(idx, value, parentSpecId, specId, skuList, s) {
            skuList.forEach(sku => {
                sku.skuSpecifications.forEach((it, sIdx) => {
                    if (it.value === value && sIdx === idx) {
                        if (s.name !== it.name) {
                            return;
                        }
                        it.propValueId = specId;
                        it.propId = parentSpecId;
                    }
                })
            })
        },
        async _getPddSpecId(idx, s, names, parentSpecId, skuList) {
            const data = await getPddSpecId({
                parentSpecId: parentSpecId,
                specNames: names
            })
            if (data) {
                const values = s.values.slice(0);
                data.forEach((spec) => {
                    const sIdx = values.findIndex(v => v.value === spec.specName);
                    if (sIdx !== -1) {
                        if (this.showPddSpec) {
                            values[sIdx].parentSpecId = spec.parentSpecId;
                            values[sIdx].specId = spec.specId;
                            values[sIdx].groupId = null;
                        } else {
                            values[sIdx].propId = spec.parentSpecId;
                            values[sIdx].propValueId = spec.specId;
                        }
                        this.updateSkuListPropValueId(idx, values[sIdx].value, spec.parentSpecId, spec.specId, skuList, s)
                    }
                })
                s.values = values;
                return Promise.resolve();
            } else {
                // const newNames = names.map(n => `【${n}】`)
                // this.$message.error(`规格值中含有违规词，请修改后重新保存！`)
                return Promise.reject();
            }
        },
        getAllSpecId(specifications, skuList) {
            const promises = [];
            let flag = false, name;
            specifications.forEach((spec, idx) => {
                let values = spec.values.map(v => v.value)
                if (values.length) {
                    let parentSpecId = spec.parentSpecId;
                    if (!parentSpecId && !this.showPddSpec) {
                        parentSpecId = this.$refs.pddSpecification.getParentSpecId(spec.name)
                    }
                    if (!parentSpecId) {
                        flag = true;
                        name = spec.name;
                    } else {
                        promises.push(this._getPddSpecId(idx, spec, values, parentSpecId, skuList));
                    }
                }
            })
            if (flag) {
              this.$message.error(`规格名列表项不包含 规格名[${name}], 请修改规格名[${name}]`)
                return Promise.reject();
            }
            return Promise.all(promises);
        },
        computedSkuList(skuList) {
            const mainProdData = this.formData;
            const outerId = mainProdData.outerId;
            skuList.forEach(sku => {
                if (sku.disabled) {
                    sku.quantity = -1;
                    if (!sku.outSkuSn) {
                        sku.outSkuSn = [outerId].concat(sku.skuSpecifications.map(sp => sp.value)).join('-');
                    }
                    if (!sku.singlePrice) {
                        sku.singlePrice = this.minMarketPrice;
                    }
                    if (!sku.multiPrice) {
                        sku.multiPrice = this.minMarketPrice - 4;
                    }
                }
                if (!sku.weight) {
                    sku.weight = 0;
                }
                const outSku = {
                    companyId: mainProdData.companyId,
                    baseItemId: mainProdData.baseItemId,
                    baseSkuId: null,
                    outGoodsId: null,
                    outSkuId: null,
                    reserveQuantity: 0,
                    limitQuantity: 999,
                    isOnsale: null,
                    spec: ''
                };
                Object.assign(sku, outSku);
            })
        },
        method_getFormData() {
            return new Promise(async (resolve, reject) => {
                let [specifications, skuList] = this.getSpecificationData()
                if (this.value.detailGallery.length > 20) {
                    resolve(false);
                    this.$message.error('商品详情图最多上传20张，请移除部分图片！')
                    return;
                }
                if (this.value.categoryIds.length) {
                    let flag = false;
                    await this.getAllSpecId(specifications, skuList).catch(e => {
                        resolve(false);
                        flag = true;
                        return;
                    })
                    if (flag) {
                        return;
                    }
                }
                if (this.showPddSpec) {
                    specifications.forEach((item, index) => {
                        item.values = item.values.map((v) => {
                            let val = {
                                ...v,
                                propId: v.parentSpecId,
                                propValueId: v.specId
                            }
                            if (index > 0) {
                                delete val.imageUrl;
                            }
                            return val;
                        })
                    })
                }
                 if (this.showPddSpec) {
                    let validSpecId = this.$refs.pddSpecification && this.$refs.pddSpecification.validate(specifications);
                    if (!validSpecId) {
                        resolve(false);
                        return;
                    }
                }
                this.value.specifications = _.cloneDeep(specifications);
                this.computedSkuList(skuList); // 新生成的sku需要设置值，库存为0
                // this.value.skuList = skuList;
                const categoryNames = this.$refs.categoryInput.method_getCategoryNames();
                const promises = [this.$refs.form.validate()];
                if (this.$refs.categoryAttr) {
                    promises.push(this.$refs.categoryAttr.validate())
                }
                const skuValid = this.validateSpecifications(specifications);
                const itemPropValues = this.putSpecToItemPropValues();
                Promise.all(promises).then(valids => {
                    if (!skuValid) {
                        resolve(false);
                    } else if (valids[0] && valids[1]) {
                        const value = this.value;
                        let data = pddDataMap({
                            ...value, itemPropValues, skuList,
                            goodsCategoryName: categoryNames[0] || '',
                            lastCategoryName: categoryNames[categoryNames.length-1] || ''
                        }, true);
                        const mainProdData = this.formData;
                        data = {
                            companyId: mainProdData.companyId,
                            baseItemId: mainProdData.baseItemId,
                            goodsId: mainProdData.outerId,
                            ...data,
                        }
                        resolve(data);
                    } else {
                        this.$message.error('请完善表单信息')
                        resolve(false);
                    }
                }).catch(e => {
                    this.$message.error('请完善表单信息')
                    resolve(false);
                })
            })
        },
        isFail(result) {
            let flag = true;
            for(let item of result) {
                if (item.failedList && item.failedList.length) {
                    flag = false;
                }
            }
            return flag;
        },
        getResultData(result) {
            const failedList = [];
            let successNum = 0;
            result.forEach(r => {
                
                if (r.failedList && r.failedList.length) {
                r.failedList.forEach(fail => {
                    failedList.push({outerId: r.outerId, ...fail})
                })
                } else {
                    successNum += 1;
                }
            });
            return {
                successNum: successNum,
                failedList: failedList
            }
        },
        async getPublishResult() {
            const res = await publishGoodsResult({taskTypeEnum: 'PIECE_ITEM'}, {isBatchUpdate: this.isBatchUpdate});
            if (res.finished) {
                return res.result || [];
            }
            return false;
        },
        start() {
            this.percentage = 0;
            const run = async () => {
                clearTimeout(this.timeoutId);
                const result = await this.getPublishResult();
                if (result) {
                    if (this.isFail(result)) {
                        this.$message.success('组合铺货成功！');
                        this.percentage = 100;
                        this.$refs.progressDialog.handleClose();
                        this.clearLoop();
                        this.visible = false;
                        this.closeStepsDialog && this.closeStepsDialog();
                    } else {
                        const resultData = this.getResultData(result);
                        let errMsg = '';
                        if (resultData.failedList[0] && resultData.failedList[0].errorMsg) {
                            errMsg = resultData.failedList[0].errorMsg
                        }
                        // this.$message.error(`组合铺货失败! ${errMsg}`);
                         this.$message({
                            type: 'error',
                            message: `组合铺货失败! ${errMsg}`,
                            duration: 0,
                            showClose: true
                        });
                        this.$refs.progressDialog.handleClose();
                        this.clearLoop();
                    }
                } else {
                    this.timeoutId = setTimeout (run, 1500)
                }
            }
            this.timeoutId = setTimeout (run, 1500)
        },
        clearLoop() {
            clearTimeout(this.timeoutId);
            clearInterval(this.intervalId);
        },
        calculation_progress(total=1) {
			let tt = 1500+(total*200)
			let x = 1, y = 50/x, t= tt/y;
			this.intervalId = setInterval(()=> {
				if(this.percentage >= 96) {
					clearInterval(this.intervalId)
				}else {
					this.percentage += x;
				}
			}, t)
		},
        async sure() {
            const data = await this.method_getFormData();
            if (data) {
                let baseSkuIds = data.skuList.map(({id}) => id).filter(Boolean);
                data.skuList.forEach(item => {
                    if (!item.disabled) {
                        item.baseSkuId = item.id
                    }
                })
                const skuFlag = this.validateSkuRows();
                if (!skuFlag) {
                    const flag = await groupProdsOnSelf({
                        publishEntrance: getPublishEntrance(this.from),
                        item: data,
                        shopIds: this.shops,
                        companyId: this.formData.companyId,
                        baseItemIds: this.baseItemIds,
                        platform: 'pdd',
                        baseSkuIds,
                    })
                    if (flag) {
                        this.handleClose();
                        this.closeFun && this.closeFun();
                        this.setCurrentPage(this.pageId ? this.pageId : `${this.routerPrefix}goods`);
                        this.publishSpeed({publishType: 'PIECE_ITEM', resultVisible: true});
                        this.onSuccess?.();
                    } else {
                        this.$message({
                            type: 'error',
                            message: `组合铺货失败!`,
                        });
                    }
                }
            }
        },
        async getList() {
            const shopList = await this.getShopList();
            this.shopList = shopList;
        },
         // 获取店铺
        async getShopList() {
            const res = await getShopList({
                source: 'pdd',
                pageNo: 1,
                pageSize: 999
            });
            return res.list || [];
        },
    },
    mounted() {
        this.getList();
    }
}
</script>

<style lang="scss" scope>
.radio-wrap > label{
    margin-right: 14px;
}
</style>